import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Award, GitBranch, Star, Network, Compass } from "lucide-react";

const HIGHLIGHTS = [
  { icon: Network, t: "See the rooms behind the records" },
  { icon: Star, t: "Reputation you can prove" },
  { icon: Award, t: "More than a bio" },
  { icon: GitBranch, t: "Built from real work" },
  { icon: Compass, t: "Find the right pathways" },
];

export const FeaturesTeaser = () => {
  return (
    <section
      id="features"
      data-testid="features-teaser-section"
      className="relative bg-loudar-ink py-24 md:py-32"
    >
      <div className="container-loudar">
        <div className="grid grid-cols-1 items-end gap-10 md:grid-cols-12">
          <div className="md:col-span-7">
            <span className="label-mono">Inside the platform</span>
            <h2
              data-testid="features-teaser-headline"
              className="mt-4 font-display text-4xl uppercase leading-[0.95] tracking-tight text-white sm:text-5xl md:text-6xl"
            >
              The Identity Layer
              <br />
              <span className="text-loudar-orange">
                For The People Behind The Music.
              </span>
            </h2>
            <p className="mt-5 max-w-xl text-base text-white/65 md:text-lg">
              An industry that's been built on word-of-mouth — finally made navigable.
              Five tools that make your reputation portable.
            </p>
            <p
              data-testid="features-teaser-promise"
              className="mt-5 max-w-xl font-display text-lg uppercase leading-snug tracking-tight text-white sm:text-xl"
            >
              LOUDAR helps you build your network and open doors that were once{" "}
              <span className="text-loudar-orange">out of reach.</span>
            </p>
          </div>
          <div className="md:col-span-5 md:text-right">
            <Link
              to="/features"
              className="btn-primary inline-flex"
              data-testid="features-teaser-cta"
            >
              Explore features <ArrowRight size={16} />
            </Link>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-5">
          {HIGHLIGHTS.map((h, i) => {
            const Icon = h.icon;
            return (
              <motion.div
                key={h.t}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.45, delay: i * 0.06 }}
                data-testid={`features-highlight-${i}`}
                className="group relative h-full rounded-sm border border-white/10 bg-loudar-surface p-5 transition-all hover:border-loudar-orange/50 hover:bg-loudar-elevated"
              >
                <span className="grid h-10 w-10 place-items-center rounded-sm border border-loudar-orange/40 bg-loudar-orange/10 text-loudar-orange">
                  <Icon size={16} />
                </span>
                <div className="mt-4 font-display text-lg uppercase leading-tight tracking-tight text-white">
                  {h.t}
                </div>
                <div className="mt-4 h-px w-8 bg-loudar-orange transition-all group-hover:w-full" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesTeaser;
